import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';

import { JobImplementationPage } from './job-implementation';
import { ProductSearchComponent } from '../../components/product-search/product-search';

@NgModule({
  declarations: [
    JobImplementationPage,
    ProductSearchComponent,
  ],
  imports: [
    IonicPageModule.forChild(JobImplementationPage),
  ],
  exports: [
    JobImplementationPage,
    ProductSearchComponent,
  ]
})
export class JobImplementationModule {}



// WEBPACK FOOTER //
// ./src/pages/job-implementation/job-implementation.module.ts